import { compact, isEmpty, map } from 'lodash/fp';

import { CONTENT_TYPE } from '../../../../../cms/constants';
import constants from '../../../../../ahm-constants';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';
import type { CustomExplainedTerm, CustomService } from './types';

const {
  URLS: {
    SALES: { EXPLAINED },
  },
} = constants;

const formatDataForContentTile = ({
  explainedTermTiles = [],
  serviceTiles = [],
}: {
  explainedTermTiles?: CustomExplainedTerm[];
  serviceTiles?: CustomService[];
}) => {
  const combinedData = compact([...explainedTermTiles, ...serviceTiles]);

  if (isEmpty(combinedData)) {
    return [];
  }
  return map((tileData) => {
    const { identifier, imageObject, slogan, summary, urlObject, __typename } = tileData;
    const sharedFields = { image: getImageAttributes({ height: 240, imageObject }), subtitle: summary, title: slogan };
    return __typename === CONTENT_TYPE.SERVICE
      ? { ...sharedFields, ctas: [{ name: urlObject?.name, url: urlObject?.url }] }
      : {
          ...sharedFields,
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'detailsTeaser' does not exist on type 'CustomService | CustomExplainedTerm'.
          ctas: [{ name: tileData?.detailsTeaser, url: `${EXPLAINED}/${identifier?.current}` }],
        };
  }, combinedData);
};

export default formatDataForContentTile;
